module.exports = __webpack_public_path__ + "static/quality-website@2x-2643a6d8e4f109f5ac1ffa620cfa0413.png";